import { Check } from '@plataforma/ui/iconos';
import { ETIQUETAS_ESTADO } from '../../formato';

const INICIO = ['lote_en_subasta', 'comprado', 'transito_aduana', 'recibido'];
const VENTA = ['en_reparacion', 'en_preparacion', 'listo', 'publicado', 'vendido'];
const DESARME = ['en_desarme', 'desarmado'];

/**
 * Etapas del vehículo (arquitectura 2.16): el camino de la subasta a la venta, o al desarme, con
 * la etapa actual marcada. El estado se lee por texto e ícono, no solo por color.
 */
export function Etapas({ estado }: { estado: string }) {
  const camino = [...INICIO, ...(DESARME.includes(estado) ? DESARME : VENTA)];
  const actual = camino.indexOf(estado);
  if (actual < 0)
    return (
      <p className="etapas-fuera">
        Etapa: <strong>{ETIQUETAS_ESTADO[estado] ?? estado}</strong>
      </p>
    );
  return (
    <ol className="etapas" aria-label="Etapas del vehículo">
      {camino.map((e, i) => {
        const clase = i < actual ? 'hecha' : i === actual ? 'actual' : 'siguiente';
        return (
          <li key={e} className={clase} aria-current={i === actual ? 'step' : undefined}>
            <span className="etapa-marca" aria-hidden="true">
              {i < actual ? <Check size={12} strokeWidth={3} /> : i + 1}
            </span>
            <span className="etapa-texto">
              {ETIQUETAS_ESTADO[e] ?? e}
              {i === actual && <span className="ui-oculto"> (etapa actual)</span>}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
